export const LIMITS = {
  FETCHING_ITEMS: 12,
  FETCHING_ADMIN_ITEMS: 8,
  FETCHING_WEBSITE_ITEMS: 24,
  MAX_FETCHING_ITEMS: 500,
} as const;

export const LIMIT_FOR_FETCHING_ITEMS = LIMITS.FETCHING_ITEMS;
export const LIMIT_FOR_FETCHING_ADMIN_ITEMS = LIMITS.FETCHING_ADMIN_ITEMS;
export const LIMIT_FOR_FETCHING_WEBSITE_ITEMS = LIMITS.FETCHING_WEBSITE_ITEMS;
export const MAX_LIMIT_FOR_FETCHING_ITEMS = LIMITS.MAX_FETCHING_ITEMS;

export const REVALIDATION_TIME = 86400;
export const EXPIRES_IN = 60 * 60 * 24 * 180;

export const SORT_TYPE = {
  _ID_ASC: '_ID_ASC',
  _ID_DESC: '_ID_DESC',
  CREATED_AT_DESC: 'CREATED_AT_DESC',
  CREATED_AT_ASC: 'CREATED_AT_ASC',
} as const;

export type SortType = (typeof SORT_TYPE)[keyof typeof SORT_TYPE];
